import { QuestionConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import { useRoomPlanConnection } from "./hooks";

export const QuestionRoomPlanConnection = () => {
	const {
		availableItemIDs,
		nameAndIDOptions,
		onSetAvailableItemIDs,
		rawAvailableItemIDs, //
	} = useRoomPlanConnection();

	const title = "利用可能なプラン";

	return (
		<QuestionConnection
			title={title}
			availableItemIDs={availableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
		/>
	);
};

QuestionRoomPlanConnection.displayName = "QuestionRoomPlanConnection";
